/* Suprimal tin opening on product pages: plays once when it scrolls into view, click or "Open again" replays it. */
(function () {
  'use strict';
  function clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function seg(p, a, b) { return clamp((p - a) / (b - a)); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function init(el) {
    if (!el || el.__sp) return; el.__sp = 1;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var num = el.querySelector('[data-tno-count]'), total = parseInt(el.getAttribute('data-count'), 10) || 30;
    var cur = 0, raf = 0, lastN = -1, played = false, live = false, running = false, DUR = 3600;
    function set(k, v) { el.style.setProperty(k, v.toFixed(4)); }
    function apply(p) {
      cur = p;
      set('--op', p);
      set('--l1', ease(seg(p, .04, .22)));
      set('--l2', ease(seg(p, .16, .42)));
      var fe = ease(seg(p, .36, .58)), fc = ease(seg(p, .66, .86));
      set('--fan', fe * (1 - fc));
      set('--q1', ease(seg(p, .62, .9)));
      if (num) { var c = Math.max(1, Math.round(seg(p, .2, .5) * total)); if (c !== lastN) { num.textContent = c; lastN = c; } }
      el.classList.toggle('is-open', p > .97);
    }
    function measure() { var w = el.clientWidth; if (w) el.style.setProperty('--u', (w / 100).toFixed(3) + 'px'); }
    function animate(from, to, ms, done) {
      cancelAnimationFrame(raf); running = true;
      var t0 = 0;
      function frame(now) {
        if (!t0) t0 = now;
        var k = clamp((now - t0) / ms);
        apply(from + (to - from) * k);
        if (k < 1) raf = requestAnimationFrame(frame);
        else { running = false; if (done) done(); }
      }
      raf = requestAnimationFrame(frame);
    }
    function play() { played = true; animate(cur, 1, DUR * (1 - cur)); }
    function replay() {
      if (running) return;
      if (cur > .02) animate(cur, 0, 650, function () { setTimeout(play, 220); });
      else play();
    }
    measure(); apply(0);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(el); else window.addEventListener('resize', measure);
    if (reduce) { el.classList.add('is-static', 'is-live'); apply(1); return; }
    el.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) return; e.preventDefault(); replay(); });
    var btn = el.querySelector('[data-tno-replay]');
    if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); replay(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          live = e.isIntersecting;
          el.classList.toggle('is-live', live);
          if (live && !played) { played = true; setTimeout(play, 380); }
        });
      }, { threshold: .35 }).observe(el);
    } else { el.classList.add('is-live'); play(); }
  }
  function boot() { [].slice.call(document.querySelectorAll('[data-sp-tno]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();